import angular from "angular";
import ngResource from "angular-resource";
import Assert from "tbAssert";

import State from "../models/State";
import OfficeFactoryModule from "../models/factories/OfficeFactory";
import TbAppConfigDataServiceModule from "../config/tb-app-config/TbAppConfigDataService";

function StateDataServiceFactory($resource, OfficeFactory, TbAppConfigDataService) {

    Assert.StrictAssert(OfficeFactory != null, "Assertion Failure: Missing Office Factory Service Dependency");
    Assert.StrictAssert(TbAppConfigDataService != null, "Assertion Failure: Missing TrackerBase Application Configuration Data Service Dependency");

    const tbServerBaseUrl = TbAppConfigDataService.tbServerBaseUrl;

    const tbStateDataApiUrl = tbServerBaseUrl + "/api/states/:stateId";
    const tbStateDetailsDataApiUrl = tbServerBaseUrl + "/api/states/:stateId/details";
    const tbStateDataApiParams = { stateId: "@stateId" };

    const makeTbStateSubscribersApiUrl =
        (stateSubTypeEndpoint) => `${tbServerBaseUrl}/api/states/:stateId/${stateSubTypeEndpoint}/:recipientId`;

    const tbStateElectionSubscribersEndpoint = "electionsubscribers";
    const tbStateEventSubscribersEndpoint = "eventsubscribers";
    const tbStateSubscribersApiParams = {stateId: "@stateId", recipientId: "@recipientId"};

    const stateDataResponseInterceptor = (serverResponse) => {

        let serverStateObj = State.FromServerState(serverResponse.data, OfficeFactory.FromServerOffice);

        angular.extend(serverResponse.resource, {
            result: serverStateObj
        });

        return serverResponse.resource;
    };

    return $resource(
        tbStateDetailsDataApiUrl,
        tbStateDataApiParams,
        {
            get: {
                url: tbStateDetailsDataApiUrl,
                method: "GET",
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: stateDataResponseInterceptor
                }
            },
            getCore: {
                url: tbStateDataApiUrl,
                method: "GET",
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: stateDataResponseInterceptor
                }
            },
            addElectionSubscription: {
                method: "PUT",
                url: makeTbStateSubscribersApiUrl(tbStateElectionSubscribersEndpoint),
                params: tbStateSubscribersApiParams,
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: stateDataResponseInterceptor
                }
            },
            removeElectionSubscription: {
                method: "DELETE",
                url: makeTbStateSubscribersApiUrl(tbStateElectionSubscribersEndpoint),
                params: tbStateSubscribersApiParams,
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: stateDataResponseInterceptor
                }
            },
            addEventSubscription: {
                method: "PUT",
                url: makeTbStateSubscribersApiUrl(tbStateEventSubscribersEndpoint),
                params: tbStateSubscribersApiParams,
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: stateDataResponseInterceptor
                }
            },
            removeEventSubscription: {
                method: "DELETE",
                url: makeTbStateSubscribersApiUrl(tbStateEventSubscribersEndpoint),
                params: tbStateSubscribersApiParams,
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: stateDataResponseInterceptor
                }
            }
        }
    );
}

StateDataServiceFactory.$inject = [ "$resource", "OfficeFactory", "TbAppConfigDataService" ];

export default angular
    .module("trackerbase-app.services.state-data-service",[
        ngResource,
        OfficeFactoryModule,
        TbAppConfigDataServiceModule
    ])
    .factory("StateData", StateDataServiceFactory)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/services/StateDataService.js
// module id = 8Ugi
// module chunks = 1